// API クライアント (fetch ラッパ). credentials を必ず付ける。
export class ApiClient {
  constructor(private base = "") {}

  async request<T>(
    path: string,
    init: RequestInit & { json?: unknown } = {},
  ): Promise<T> {
    const headers = new Headers(init.headers);
    if (init.json !== undefined) {
      headers.set("content-type", "application/json");
      init.body = JSON.stringify(init.json);
    }
    const res = await fetch(this.base + path, {
      ...init,
      headers,
      credentials: "include",
    });
    const text = await res.text();
    let data: unknown = null;
    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = text;
      }
    }
    if (!res.ok) {
      const code =
        (data as { error?: { code?: string } } | null)?.error?.code ??
        "http_error";
      const message =
        (data as { error?: { message?: string } } | null)?.error?.message ??
        `HTTP ${res.status}`;
      const e = new Error(message);
      (e as Error & { code?: string; status?: number }).code = code;
      (e as Error & { code?: string; status?: number }).status = res.status;
      throw e;
    }
    return data as T;
  }

  get<T>(p: string) {
    return this.request<T>(p);
  }
  post<T>(p: string, json?: unknown) {
    return this.request<T>(p, { method: "POST", json });
  }
  patch<T>(p: string, json?: unknown) {
    return this.request<T>(p, { method: "PATCH", json });
  }
  put<T>(p: string, json?: unknown) {
    return this.request<T>(p, { method: "PUT", json });
  }
  delete<T>(p: string, json?: unknown) {
    return this.request<T>(p, { method: "DELETE", json });
  }
}

export const api = new ApiClient("/api");
